// extracted by mini-css-extract-plugin
export default {"slickPrev":"PreviousArrow_slickPrev__VtpY9"};